import Container from 'common/components/Container';
import {
  PrincingPageHeader,
  Princing,
  Description,
} from './pricingPage.style';
import { useEffect, useState } from 'react';
import PurchaseCredit from './PurchaseCredit/PurchaseCredit';
import SubscriptionPlans from './SubscriptionPlans/SubscriptionPlans';
import TokenUsage from './TokenUsage/TokenUsage';
import { Box, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { useRouter } from 'next/router';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import { saasModernTheme } from 'common/theme/saasModern';
import BtnContact from 'common/components/Button/BTNContact';
import BtnGetStarted from 'common/components/Button/BTNGetStarted';
import PricingFeatureDefault from './PricingTable/PricingFeature';
import PricingInfoCards from './PricingInfoCards/PricingInfoCards';
import SocialProofSection from './SocialProofSection/SocialProofSection';
import config from 'config/config';


const PricingPage = ({ locale, data }) => {
  const { query, push } = useRouter();
  const { t } = useTranslations();

  const [allPlans, setAllPlans] = useState([]);
  const [dataPricings, setDataPricings] = useState(null);
  const [plans, setPlans] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchAllPlans = async () => {
      try {
        // Récupérer les plans SOLO
        const soloResponse = await fetch(config.endPointGetPricing, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ planType: 'SOLO' }),
        });

        // Récupérer les plans TEAM
        const teamResponse = await fetch(config.endPointGetPricing, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ planType: 'TEAM' }),
        });

        // Combiner tous les plans dans un seul tableau
        const combinedPlans = [];
        
        if (soloResponse.ok) {
          const soloData = await soloResponse.json();
          combinedPlans.push(...soloData);
        }

        if (teamResponse.ok) {
          const teamData = await teamResponse.json();
          combinedPlans.push(...teamData);
        }

        // Trier les plans pour mettre ENTERPRISE à la fin
        const sortedPlans = combinedPlans.sort((a, b) => {
          if (a.code === 'ENTERPRISE') return 1;
          if (b.code === 'ENTERPRISE') return -1;
          return 0;
        });
        
        setAllPlans(sortedPlans);

        // Récupérer les détails pour la table de comparaison
        const pricingUrl = `https://graphql.swiftask.ai/public/sub_plans_details?isYearly=false&isEnterprise=false`;
        const res = await fetch(pricingUrl);
        const json = await res.json();
        setDataPricings(json);
        setPlans(json.plans || []);
        setCategories(json.categories || []);
      } catch (err) {
        console.error('Erreur lors du chargement des données de pricing:', err);
      }
    };

    fetchAllPlans();
  }, []);

  return (
    <>
      <Container>
        <PrincingPageHeader>
          <PrismicRichText
            field={data.title}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="h1"
                  sx={{
                    width: ['100%', '100%', '80%'],
                    fontSize: ['40px', '44px', '64px'],
                    marginTop: ['10px', '0', '85px'],
                    fontFamily: saasModernTheme.fontFamily,
                    lineHeight: ['45px', '65px'],
                    fontWeight: 800,
                    '.font-semibold': {
                      background:
                        saasModernTheme.customColor.inversGradiantColor,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                  }}
                >
                  {children}
                </Typography>
              ),
            }}
          />
          <Description>{data.description_title}</Description>
          <Box
            sx={{
              marginBottom: ['50px', '80px'],
              marginTop: ['10px', '20px'],
            }}
          >
            <BtnContact label={data.btncta} locale={locale} />
          </Box>
        </PrincingPageHeader>

      </Container>
      
      {/* Wide container just for plans section */}
      <Container wide>
        {/* Tous les plans en horizontal */}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mt: 4,
            width: '100%',
            flexWrap: 'wrap',
            justifyContent: ['center', 'space-between', 'flex-start'],
            mb: 6,
          }}
        >
          <SubscriptionPlans subplans={allPlans} />
        </Box>
      </Container>

      <Container>

        {/* Section des cartes informatives */}
        <PricingInfoCards />
      </Container>

      {/* Section de preuve sociale
      <SocialProofSection /> */}

      <Container>

        {/* <TokenUsage
          subPlansTokenUsage={data.subPlansTokenUsage}
          botsUseCaseLabel={data.botsUseCaseLabel}
          locale={locale}
        />
          <PricingFeatureDefault
            detailUrl = {selectedValue}
            plans={plans}
            categories={categories}
            locale={locale}
          /> */}
        <Princing>
          <PrismicRichText
            field={data.buyingcredittitle}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="h2"
                  sx={{
                    width: '80%',
                    fontSize: ['30px', '48px'],
                    fontFamily: saasModernTheme.fontFamily,
                    lineHeight: ['45px', '65px'],
                    margin: '50px 0 30px 0',

                    fontWeight: 800,
                    '.font-semibold': {
                      background: saasModernTheme.customColor.gradiantColor,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                  }}
                >
                  {children}
                </Typography>
              ),
            }}
          />

          <BtnGetStarted label={data.buying_credits_button} />
        </Princing>
      </Container>
    </>
  );
};

export default PricingPage;
